import { supabase } from './supabase';

type RpcError={message:string};
export type NavigationItem={key:string;label:string;route:string;group:'home'|'departments'|'administration'};
export type AppNavigationWorkspace={contract_version:string;organization_id:string;items:NavigationItem[];roles:{role_key:string;role_name:string}[]};

export async function getAppNavigation(organizationId:string):Promise<{data:AppNavigationWorkspace|null;error:RpcError|null}>{
  const r=await supabase.rpc('get_app_navigation_workspace_v2',{p_organization_id:organizationId});
  return {data:(r.data??null) as AppNavigationWorkspace|null,error:r.error?{message:r.error.message}:null};
}
